// extracted by mini-css-extract-plugin
export var actionText = "_kw-4";
export var container = "_kw-0";
export var leftSection = "_kw-1";
export var rightSection = "_kw-2";
export var settingsButton = "_kw-6";
export var settingsIcon = "_kw-7";
export var shortcut = "_kw-5";
export var shortcutGroup = "_kw-3";